export const CASH_MOVEMENT_ADD = 'ADD'
export const CASH_MOVEMENT_REMOVE = 'REMOVE'
export const CASH_MOVEMENT_INITIAL = 'INITIAL'

export const Types = [
  {
    code: CASH_MOVEMENT_ADD,
    label: 'Cash-In'
  },
  {
    code: CASH_MOVEMENT_REMOVE,
    label: 'Cash-Out'
  },
  {
    code: CASH_MOVEMENT_INITIAL,
    label: 'Open Cash Register'
  }
]

export function getLabel (code) {
  return _.get(Types.find((x) => x.code === code), 'label')
}

export default Types



// WEBPACK FOOTER //
// ./src/utils/types/cash-movement.js